// Утилиты для красивого отображения audit log записей

const entityLabels: Record<string, string> = {
  category: 'Категория',
  domain: 'Домен',
  ip_group: 'Группа IP',
  ip_range: 'IP-диапазон',
  happ_rule_set: 'Набор Happ',
  happ_tag: 'Happ-тег',
  target: 'Эндпоинт',
  panel: 'Панель',
  setting: 'Настройка',
  user: 'Пользователь',
  api_token: 'API-токен'
}

const actionLabels: Record<string, string> = {
  create: 'создан',
  update: 'изменён',
  delete: 'удалён',
  'bulk-create': 'массовое создание',
  'regenerate-token': 'смена токена',
  fetch: 'скачан',
  sync: 'синхронизирован',
  'sync-error': 'ошибка синхронизации'
}

export function formatEntity(entityType: string, entityId: number | null): string {
  const label = entityLabels[entityType] || entityType
  return entityId ? `${label} #${entityId}` : label
}

export function formatAction(action: string): string {
  return actionLabels[action] || action
}

function shortValue(v: any): string {
  if (v == null) return '—'
  if (typeof v === 'string') {
    if (v.length > 40) return v.slice(0, 40) + '…'
    return v
  }
  if (typeof v === 'boolean') return v ? 'да' : 'нет'
  if (Array.isArray(v)) return `[${v.length}]`
  if (typeof v === 'object') return JSON.stringify(v).slice(0, 40)
  return String(v)
}

const fieldLabels: Record<string, string> = {
  name: 'название',
  slug: 'slug',
  key: 'ключ',
  address: 'адрес',
  value: 'значение',
  type: 'тип',
  role: 'роль',
  enabled: 'активно',
  autoSync: 'автосинхр.',
  syncIntervalSec: 'интервал',
  tagType: 'тип тега',
  addressList: 'address-list',
  updated: 'обновлено',
  error: 'ошибка'
}

/**
 * Извлекает понятное описание изменений из payload.
 */
export function formatPayload(payload: string | null): string {
  if (!payload) return ''
  let obj: any
  try { obj = JSON.parse(payload) } catch { return payload.slice(0, 60) }
  if (obj == null || typeof obj !== 'object') return String(obj)

  const parts: string[] = []
  const priority = ['name', 'slug', 'key', 'address', 'value', 'type', 'role', 'enabled', 'tagType', 'addressList', 'updated', 'error']
  for (const key of priority) {
    if (obj[key] !== undefined) {
      const label = fieldLabels[key] || key
      parts.push(`${label}: ${shortValue(obj[key])}`)
    }
  }
  const shown = new Set(priority)
  for (const [k, v] of Object.entries(obj)) {
    if (shown.has(k)) continue
    if (k === 'notes' && v) parts.push(`заметка: ${shortValue(v)}`)
    if (k === 'comment' && v) parts.push(`комментарий: ${shortValue(v)}`)
    if (k === 'description' && v) parts.push(`описание: ${shortValue(v)}`)
    if (k === 'categoryId' || k === 'groupId' || k === 'ruleSetId' || k === 'targetId') {
      parts.push(`${k.replace('Id', '')}: #${v}`)
    }
    if (k === 'categoryIds' && Array.isArray(v)) parts.push(`категорий: ${v.length}`)
    if (k === 'ipGroupIds' && Array.isArray(v)) parts.push(`IP групп: ${v.length}`)
    if (k === 'ruleSetIds' && Array.isArray(v)) parts.push(`наборов Happ: ${v.length}`)
  }
  if (parts.length === 0) return ''
  return parts.slice(0, 3).join(' · ')
}
